import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Card } from '@/components/ui/card';

interface KeyboardShortcutsProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const shortcuts = [
  {
    category: 'Canvas',
    items: [
      { keys: ['Right-click'], description: 'Add nodes to canvas' },
      { keys: ['Ctrl', 'Z'], description: 'Undo (coming soon)' },
      { keys: ['Ctrl', 'Y'], description: 'Redo (coming soon)' },
      { keys: ['Delete'], description: 'Delete selected node' },
      { keys: ['Backspace'], description: 'Delete selected node' },
    ],
  },
  {
    category: 'Workflow',
    items: [
      { keys: ['Ctrl', 'S'], description: 'Save workflow (use button)' },
      { keys: ['Ctrl', 'Enter'], description: 'Run workflow (use button)' },
      { keys: ['Escape'], description: 'Deselect node' },
    ],
  },
  {
    category: 'Navigation',
    items: [
      { keys: ['Ctrl', 'K'], description: 'Open command palette' },
      { keys: ['Cmd', 'K'], description: 'Open command palette (Mac)' },
      { keys: ['?'], description: 'Show this help' },
    ],
  },
];

export function KeyboardShortcuts({ open, onOpenChange }: KeyboardShortcutsProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Keyboard Shortcuts</DialogTitle>
        </DialogHeader>

        <div className="space-y-6 max-h-96 overflow-y-auto">
          {shortcuts.map((group) => (
            <div key={group.category} className="space-y-3">
              <h3 className="font-semibold text-foreground text-sm">{group.category}</h3>
              <div className="space-y-2">
                {group.items.map((item, idx) => (
                  <div
                    key={idx}
                    className="flex items-center justify-between p-3 rounded border border-border hover:bg-muted/50 transition-colors"
                  >
                    <p className="text-sm text-muted-foreground flex-1">{item.description}</p>
                    <div className="flex gap-1">
                      {item.keys.map((key, i) => (
                        <span key={i} className="flex items-center gap-0.5">
                          <kbd className="px-2 py-1 text-xs font-semibold text-foreground bg-muted border border-border rounded">
                            {key}
                          </kbd>
                          {i < item.keys.length - 1 && <span className="text-xs text-muted-foreground">+</span>}
                        </span>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="text-xs text-muted-foreground">
          <p>Press <kbd className="px-1.5 py-0.5 bg-muted border border-border rounded text-xs">?</kbd> anywhere to toggle shortcuts</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
